import { Fieldset, Radio, useRadioGroup } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import { SummaryCard } from '../../../expertRegistration/json/common/summary/styledComponents';
import { useChangeLanguage } from '../../../expertRegistration/common/hooks/useChangeLanguage';
import { CertificateVisibility, SimpleEnergyAnalysis } from '../../../../types/building';

interface Props {
  energyAnalysis: SimpleEnergyAnalysis;
}

export const MalformOgSynlighetViewer: FC<Props> = ({ energyAnalysis }) => {
  const { t } = useTranslation();
  const { malform } = useChangeLanguage(energyAnalysis);
  const synlighet = energyAnalysis.energiplan?.synlighet;

  const { getRadioProps: getMaalformProps } = useRadioGroup({
    name: 'maalform',
    value: malform
  });

  const { getRadioProps: getVisibilityProps } = useRadioGroup({
    name: 'visibility',
    value: synlighet
  });

  const getVisibilityLabel = (visibility: CertificateVisibility): string => {
    const labels: Record<CertificateVisibility, string> = {
      offentlig: 'grant',
      reservert: 'revoke'
    };

    return labels[visibility];
  };

  return (
    <SummaryCard>
      <Fieldset>
        <Fieldset.Legend>{t('form.samtykke.maalform.header')}</Fieldset.Legend>
        <Radio
          {...getMaalformProps({ value: malform })}
          value={malform}
          label={t(`form.samtykke.maalform.${malform}`)}
          readOnly
        />
        <Fieldset.Legend>{t('form.samtykke.deling.radio.title')}</Fieldset.Legend>
        {synlighet && (
          <Radio
            {...getVisibilityProps({ value: synlighet })}
            label={t(`form.samtykke.deling.radio.${getVisibilityLabel(synlighet)}`)}
            readOnly
          />
        )}
      </Fieldset>
    </SummaryCard>
  );
};
